var exports = {
  "uu": "VoiceLobbyShared.module__actionButtons___V3d5eG",
  "hP": "VoiceLobbyShared.module__actionButton___V3d5eG",
  "zc": "VoiceLobbyShared.module__iconContainer___V3d5eG",
  "KA": "VoiceLobbyShared.module__iconContainerBrand___V3d5eG",
  "cF": "VoiceLobbyShared.module__iconContainerDanger___V3d5eG",
  "hO": "VoiceLobbyShared.module__iconContainerTertiary___V3d5eG",
  "cY": "VoiceLobbyShared.module__iconContainerSuccess___V3d5eG",
  "gE": "VoiceLobbyShared.module__actionIcon___V3d5eG",
  "uI": "VoiceLobbyShared.module__actionIconSecondary___V3d5eG",
  "K2": "VoiceLobbyShared.module__actionText___V3d5eG",
  "Hd": "VoiceLobbyShared.module__connectionInfo___V3d5eG",
  "Il": "VoiceLobbyShared.module__connectionHeader___V3d5eG",
  "p1": "VoiceLobbyShared.module__connectionStatusInfo___V3d5eG",
  "bn": "VoiceLobbyShared.module__connectionTitle___V3d5eG",
  "fV": "VoiceLobbyShared.module__connectionSubtitle___V3d5eG",
  "Cb": "VoiceLobbyShared.module__connectionStatusDot___V3d5eG",
  "wL": "VoiceLobbyShared.module__statsGrid___V3d5eG",
  "N8": "VoiceLobbyShared.module__statRow___V3d5eG",
  "Zh": "VoiceLobbyShared.module__statLabel___V3d5eG",
  "cR": "VoiceLobbyShared.module__statValue___V3d5eG",
  "_x": "VoiceLobbyShared.module__statValuePrimary___V3d5eG",
  "V4": "VoiceLobbyShared.module__endpointValue___V3d5eG",
  "TR": "VoiceLobbyShared.module__connectionIdValue___V3d5eG",
  "JX": "VoiceLobbyShared.module__maxWidth___V3d5eG",
};

module.exports = exports;
